import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import Button from './Buttons';

// error: optional message from a refused delete (e.g. the assessment is being analyzed), shown on the confirm step.
const DeleteAssessmentModal = ({ isOpen, onClose, onConfirm, isDeleting, error }) => {
  const [step, setStep] = useState(1);
  const [confirmText, setConfirmText] = useState('');

  useEffect(() => {
    if (isOpen) {
      setStep(1);
      setConfirmText('');
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete Assessment" size="md">
      {step === 1 ? (
        <div>
          <p className="text-sm text-content-primary mb-6">
            Deleting this assessment will delete all risks and remediations associated with this assessment. Are you sure you want to delete this assessment? This operation cannot be undone.
          </p>
          <div className="flex justify-end space-x-3">
            <Button variant="secondary" onClick={onClose}>
              Go Back
            </Button>
            <Button variant="danger" onClick={() => setStep(2)}>
              Yes
            </Button>
          </div>
        </div>
      ) : (
        <div>
          <p className="text-sm text-content-primary mb-4">
            Type <span className="font-semibold">Confirm</span> to verify you want to delete this assessment and all of its associated risks and remediations. This operation cannot be undone.
          </p>
          <input
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder="Type 'Confirm' here"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 mb-4"
            autoFocus
          />
          {error && (
            <p role="alert" className="text-sm text-red-600 mb-4">{error}</p>
          )}
          <div className="flex justify-end space-x-3">
            <Button variant="secondary" onClick={onClose}>
              Go Back
            </Button>
            <Button
              variant="danger"
              disabled={confirmText !== 'Confirm' || isDeleting}
              onClick={onConfirm}
            >
              {isDeleting ? 'Deleting...' : 'Delete'}
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default DeleteAssessmentModal;
